import { writable } from 'svelte/store'

function createStore() {
    const { subscribe, set, update } = writable([])

    return {
        subscribe,
        set: (data) => {
            data.sort((a, b) => a.messagesPerMinute - b.messagesPerMinute)
            set(data)
        },
        add: (data) => {
            update((store) => {
                store.push(data)
                store.sort((a, b) => a.messagesPerMinute - b.messagesPerMinute)
                return store
            })
        },
        update: (config) => {
            update((store) => {
                const index = store.findIndex((item) => {
                    return item._id === config._id
                })
                if (index != -1) {
                    store[index] = config
                }
                store.sort((a, b) => a.messagesPerMinute - b.messagesPerMinute)
                return [...store]
            })
        },
        remove: (chatConfigId) => {
            update((store) => {
                const newStore = store.slice().filter((item) => {
                    return item._id !== chatConfigId
                })
                return newStore
            })
        },
        removeByConfig: (config) => {
            update((store) => {
                const newStore = store.slice().filter((item) => {
                    return item != config
                })
                return newStore
            })
        },
    }
}

export const chatStore = createStore()
